"use strict";
document.addEventListener('DOMContentLoaded', () => {
    const countdownElements = document.querySelectorAll('.js-countdown-timer');
    if (!countdownElements.length)
        return;
    const units = [
        { key: 'd', label: 'day', ms: 1000 * 60 * 60 * 24 },
        { key: 'h', label: 'hour', ms: 1000 * 60 * 60 },
        { key: 'm', label: 'minute', ms: 1000 * 60 },
        { key: 's', label: 'second', ms: 1000 }
    ];
    const formatDisplayValue = (value, unitLabel, showUnit) => {
        if (showUnit) {
            const pluralizedLabel = value === 1 ? unitLabel : `${unitLabel}s`;
            return `${value} ${pluralizedLabel} `;
        }
        else {
            return `${value}`;
        }
    };
    const getInitialUnitIndex = () => {
        const loweredFormat = 'd';
        const idx = units.findIndex(u => loweredFormat.includes(u.key));
        return idx === -1 ? 0 : idx;
    };
    const getUnitValue = (distance, unitIdx) => {
        switch (units[unitIdx].key) {
            case 'd':
                return Math.floor(distance / units[unitIdx].ms);
            case 'h':
                return Math.floor((distance % (1000 * 60 * 60 * 24)) / units[unitIdx].ms);
            case 'm':
                return Math.floor((distance % (1000 * 60 * 60)) / units[unitIdx].ms);
            case 's':
                return Math.floor((distance % (1000 * 60)) / units[unitIdx].ms);
            default:
                return 0;
        }
    };
    countdownElements.forEach(countdownElement => {
        const endDateString = countdownElement.dataset.endDate;
        const completedMsg = countdownElement.dataset.completedMsg;
        const endTimestamp = new Date(endDateString).getTime();
        let currentUnitIndex = getInitialUnitIndex();
        let intervalId = null;
        const updateCountdown = () => {
            const now = Date.now();
            const timeRemaining = endTimestamp - now;
            if (timeRemaining < 0) {
                clearInterval(intervalId);
                if (completedMsg) {
                    const completedMsgEl = document.createElement('span');
                    completedMsgEl.className = 'js-countdown-completed';
                    completedMsgEl.textContent = completedMsg;
                    countdownElement.innerHTML = '';
                    countdownElement.appendChild(completedMsgEl);
                }
                else {
                    countdownElement.parentNode && countdownElement.parentNode.removeChild(countdownElement);
                }
                return;
            }
            const nextUnitIndex = units.findIndex((unit, idx) => timeRemaining >= unit.ms || idx === units.length - 1);
            if (nextUnitIndex !== currentUnitIndex) {
                clearInterval(intervalId);
                currentUnitIndex = nextUnitIndex;
                intervalId = setInterval(updateCountdown, units[currentUnitIndex].ms);
            }
            const value = getUnitValue(timeRemaining, currentUnitIndex);
            countdownElement.querySelectorAll('.js-countdown-number').forEach(function (el) {
                el.innerHTML = formatDisplayValue(value, units[currentUnitIndex].label);
            });
            countdownElement.querySelectorAll('.js-countdown-unit').forEach(function (el) {
                el.textContent = `${units[currentUnitIndex].label}${value !== 1 ? 's' : ''}`;
            });
        };
        intervalId = setInterval(updateCountdown, units[currentUnitIndex].ms);
        updateCountdown();
    });
});
//# sourceMappingURL=ds-countdown-timer.js.map